import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'debounce';

import CartActions from '~redux/Cart/actions';

const WAIT = 2000;
const debouncedCreateOrUpdateCart = debounce(
  (dispatch) => dispatch(CartActions.createOrUpdateRemoteCart()),
  WAIT
);

export function useRegisterCartChanges() {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.cart);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const storeId = useSelector((state) => state.searchStore.currentSubsidiary?.id);
  const dispatchMethod = useSelector((state) => state.searchStore.dispatchType);

  useEffect(() => {
    debouncedCreateOrUpdateCart(dispatch);
  }, [cart, currentUser, dispatch, storeId, dispatchMethod]);
}
